import moment from 'moment-timezone';

export const BUSINESS_TIMEZONE = 'America/Toronto';

export const getTodayInBusinessTimezone = (): string => {
  return moment().tz(BUSINESS_TIMEZONE).format('YYYY-MM-DD');
};
